const MAX_CAPACITY = 2147483647;
const WHOLE_NUMBER = /^\d+$/;
const PRICE = /^\d{1,13}(\.\d{1,2})?$/;

export function capacityError(value, { minimum = 1, required = true } = {}) {
  const capacity = String(value ?? "").trim();
  if (capacity === "" && !required) return null;
  if (!WHOLE_NUMBER.test(capacity) || Number(capacity) < 1) return "Enter a whole number of 1 or more.";
  if (Number(capacity) > MAX_CAPACITY) return `Enter ${MAX_CAPACITY.toLocaleString("en-US")} or fewer.`;
  if (Number(capacity) < minimum) return `${minimum} spot${minimum === 1 ? " is" : "s are"} already taken, so capacity can't go below ${minimum}.`;
  return null;
}

export function priceError(value, { required = true } = {}) {
  const price = String(value ?? "").trim();
  if (price === "" && !required) return null;
  if (!PRICE.test(price)) return "Enter a price of 0 or more, with up to 2 decimal places.";
  return null;
}

export default function pricingErrors(form, { spotsTaken = 0 } = {}) {
  const errors = {};
  const capacity = capacityError(form.capacity, { minimum: Math.max(1, spotsTaken) });
  if (capacity) errors.capacity = capacity;
  const price = priceError(form.price);
  if (price) errors.price = price;
  const refundWindow = String(form.refund_window_days ?? "").trim();
  if (!WHOLE_NUMBER.test(refundWindow) || Number(refundWindow) > MAX_CAPACITY) errors.refund_window_days = "Enter a whole number of days, 0 or more.";
  return errors;
}
